/**
 * ISO 4217 currency catalogue — GENERATED FILE.
 * Source: backend/services/iso4217.py  (regenerate: python /app/scripts/gen_frontend_currencies.py)
 * Do not hand-edit; add currencies backend-side then regenerate.
 */
export const CURRENCIES = [
  {
    "code": "AED",
    "name": "UAE Dirham",
    "symbol": "د.إ",
    "decimals": 2,
    "countries": "United Arab Emirates"
  },
  {
    "code": "AFN",
    "name": "Afghan Afghani",
    "symbol": "؋",
    "decimals": 2,
    "countries": "Afghanistan"
  },
  {
    "code": "ALL",
    "name": "Albanian Lek",
    "symbol": "L",
    "decimals": 2,
    "countries": "Albania"
  },
  {
    "code": "AMD",
    "name": "Armenian Dram",
    "symbol": "֏",
    "decimals": 2,
    "countries": "Armenia"
  },
  {
    "code": "ANG",
    "name": "Netherlands Antillean Guilder",
    "symbol": "ƒ",
    "decimals": 2,
    "countries": "Curaçao, Sint Maarten"
  },
  {
    "code": "AOA",
    "name": "Angolan Kwanza",
    "symbol": "Kz",
    "decimals": 2,
    "countries": "Angola"
  },
  {
    "code": "ARS",
    "name": "Argentine Peso",
    "symbol": "$",
    "decimals": 2,
    "countries": "Argentina"
  },
  {
    "code": "AUD",
    "name": "Australian Dollar",
    "symbol": "A$",
    "decimals": 2,
    "countries": "Australia, Nauru, Kiribati, Tuvalu"
  },
  {
    "code": "AWG",
    "name": "Aruban Florin",
    "symbol": "ƒ",
    "decimals": 2,
    "countries": "Aruba"
  },
  {
    "code": "AZN",
    "name": "Azerbaijani Manat",
    "symbol": "₼",
    "decimals": 2,
    "countries": "Azerbaijan"
  },
  {
    "code": "BAM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol": "KM",
    "decimals": 2,
    "countries": "Bosnia and Herzegovina"
  },
  {
    "code": "BBD",
    "name": "Barbadian Dollar",
    "symbol": "Bds$",
    "decimals": 2,
    "countries": "Barbados"
  },
  {
    "code": "BDT",
    "name": "Bangladeshi Taka",
    "symbol": "৳",
    "decimals": 2,
    "countries": "Bangladesh"
  },
  {
    "code": "BGN",
    "name": "Bulgarian Lev",
    "symbol": "лв",
    "decimals": 2,
    "countries": "Bulgaria"
  },
  {
    "code": "BHD",
    "name": "Bahraini Dinar",
    "symbol": "BD",
    "decimals": 3,
    "countries": "Bahrain"
  },
  {
    "code": "BIF",
    "name": "Burundian Franc",
    "symbol": "FBu",
    "decimals": 0,
    "countries": "Burundi"
  },
  {
    "code": "BMD",
    "name": "Bermudian Dollar",
    "symbol": "BD$",
    "decimals": 2,
    "countries": "Bermuda"
  },
  {
    "code": "BND",
    "name": "Brunei Dollar",
    "symbol": "B$",
    "decimals": 2,
    "countries": "Brunei"
  },
  {
    "code": "BOB",
    "name": "Bolivian Boliviano",
    "symbol": "Bs",
    "decimals": 2,
    "countries": "Bolivia"
  },
  {
    "code": "BRL",
    "name": "Brazilian Real",
    "symbol": "R$",
    "decimals": 2,
    "countries": "Brazil"
  },
  {
    "code": "BSD",
    "name": "Bahamian Dollar",
    "symbol": "B$",
    "decimals": 2,
    "countries": "Bahamas"
  },
  {
    "code": "BTN",
    "name": "Bhutanese Ngultrum",
    "symbol": "Nu.",
    "decimals": 2,
    "countries": "Bhutan"
  },
  {
    "code": "BWP",
    "name": "Botswana Pula",
    "symbol": "P",
    "decimals": 2,
    "countries": "Botswana"
  },
  {
    "code": "BYN",
    "name": "Belarusian Ruble",
    "symbol": "Br",
    "decimals": 2,
    "countries": "Belarus"
  },
  {
    "code": "BZD",
    "name": "Belize Dollar",
    "symbol": "BZ$",
    "decimals": 2,
    "countries": "Belize"
  },
  {
    "code": "CAD",
    "name": "Canadian Dollar",
    "symbol": "C$",
    "decimals": 2,
    "countries": "Canada"
  },
  {
    "code": "CDF",
    "name": "Congolese Franc",
    "symbol": "FC",
    "decimals": 2,
    "countries": "Democratic Republic of the Congo"
  },
  {
    "code": "CHF",
    "name": "Swiss Franc",
    "symbol": "CHF",
    "decimals": 2,
    "countries": "Switzerland, Liechtenstein"
  },
  {
    "code": "CLP",
    "name": "Chilean Peso",
    "symbol": "$",
    "decimals": 0,
    "countries": "Chile"
  },
  {
    "code": "CNY",
    "name": "Chinese Yuan Renminbi",
    "symbol": "¥",
    "decimals": 2,
    "countries": "China"
  },
  {
    "code": "COP",
    "name": "Colombian Peso",
    "symbol": "$",
    "decimals": 2,
    "countries": "Colombia"
  },
  {
    "code": "CRC",
    "name": "Costa Rican Colón",
    "symbol": "₡",
    "decimals": 2,
    "countries": "Costa Rica"
  },
  {
    "code": "CUP",
    "name": "Cuban Peso",
    "symbol": "₱",
    "decimals": 2,
    "countries": "Cuba"
  },
  {
    "code": "CVE",
    "name": "Cape Verdean Escudo",
    "symbol": "$",
    "decimals": 2,
    "countries": "Cabo Verde"
  },
  {
    "code": "CZK",
    "name": "Czech Koruna",
    "symbol": "Kč",
    "decimals": 2,
    "countries": "Czechia"
  },
  {
    "code": "DJF",
    "name": "Djiboutian Franc",
    "symbol": "Fdj",
    "decimals": 0,
    "countries": "Djibouti"
  },
  {
    "code": "DKK",
    "name": "Danish Krone",
    "symbol": "kr",
    "decimals": 2,
    "countries": "Denmark, Greenland, Faroe Islands"
  },
  {
    "code": "DOP",
    "name": "Dominican Peso",
    "symbol": "RD$",
    "decimals": 2,
    "countries": "Dominican Republic"
  },
  {
    "code": "DZD",
    "name": "Algerian Dinar",
    "symbol": "DA",
    "decimals": 2,
    "countries": "Algeria"
  },
  {
    "code": "EGP",
    "name": "Egyptian Pound",
    "symbol": "E£",
    "decimals": 2,
    "countries": "Egypt"
  },
  {
    "code": "ERN",
    "name": "Eritrean Nakfa",
    "symbol": "Nfk",
    "decimals": 2,
    "countries": "Eritrea"
  },
  {
    "code": "ETB",
    "name": "Ethiopian Birr",
    "symbol": "Br",
    "decimals": 2,
    "countries": "Ethiopia"
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "decimals": 2,
    "countries": "Eurozone, Germany, France, Ireland, Italy, Spain, Netherlands, Portugal, Greece, Croatia"
  },
  {
    "code": "FJD",
    "name": "Fijian Dollar",
    "symbol": "FJ$",
    "decimals": 2,
    "countries": "Fiji"
  },
  {
    "code": "FKP",
    "name": "Falkland Islands Pound",
    "symbol": "£",
    "decimals": 2,
    "countries": "Falkland Islands"
  },
  {
    "code": "GBP",
    "name": "British Pound Sterling",
    "symbol": "£",
    "decimals": 2,
    "countries": "United Kingdom, England, Scotland, Wales, Northern Ireland"
  },
  {
    "code": "GEL",
    "name": "Georgian Lari",
    "symbol": "₾",
    "decimals": 2,
    "countries": "Georgia"
  },
  {
    "code": "GHS",
    "name": "Ghanaian Cedi",
    "symbol": "GH₵",
    "decimals": 2,
    "countries": "Ghana"
  },
  {
    "code": "GIP",
    "name": "Gibraltar Pound",
    "symbol": "£",
    "decimals": 2,
    "countries": "Gibraltar"
  },
  {
    "code": "GMD",
    "name": "Gambian Dalasi",
    "symbol": "D",
    "decimals": 2,
    "countries": "Gambia"
  },
  {
    "code": "GNF",
    "name": "Guinean Franc",
    "symbol": "FG",
    "decimals": 0,
    "countries": "Guinea"
  },
  {
    "code": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol": "Q",
    "decimals": 2,
    "countries": "Guatemala"
  },
  {
    "code": "GYD",
    "name": "Guyanese Dollar",
    "symbol": "G$",
    "decimals": 2,
    "countries": "Guyana"
  },
  {
    "code": "HKD",
    "name": "Hong Kong Dollar",
    "symbol": "HK$",
    "decimals": 2,
    "countries": "Hong Kong"
  },
  {
    "code": "HNL",
    "name": "Honduran Lempira",
    "symbol": "L",
    "decimals": 2,
    "countries": "Honduras"
  },
  {
    "code": "HTG",
    "name": "Haitian Gourde",
    "symbol": "G",
    "decimals": 2,
    "countries": "Haiti"
  },
  {
    "code": "HUF",
    "name": "Hungarian Forint",
    "symbol": "Ft",
    "decimals": 2,
    "countries": "Hungary"
  },
  {
    "code": "IDR",
    "name": "Indonesian Rupiah",
    "symbol": "Rp",
    "decimals": 2,
    "countries": "Indonesia"
  },
  {
    "code": "ILS",
    "name": "Israeli New Shekel",
    "symbol": "₪",
    "decimals": 2,
    "countries": "Israel, Palestine"
  },
  {
    "code": "INR",
    "name": "Indian Rupee",
    "symbol": "₹",
    "decimals": 2,
    "countries": "India, Bhutan"
  },
  {
    "code": "IQD",
    "name": "Iraqi Dinar",
    "symbol": "ID",
    "decimals": 3,
    "countries": "Iraq"
  },
  {
    "code": "IRR",
    "name": "Iranian Rial",
    "symbol": "﷼",
    "decimals": 2,
    "countries": "Iran"
  },
  {
    "code": "ISK",
    "name": "Icelandic Króna",
    "symbol": "kr",
    "decimals": 0,
    "countries": "Iceland"
  },
  {
    "code": "JMD",
    "name": "Jamaican Dollar",
    "symbol": "J$",
    "decimals": 2,
    "countries": "Jamaica"
  },
  {
    "code": "JOD",
    "name": "Jordanian Dinar",
    "symbol": "JD",
    "decimals": 3,
    "countries": "Jordan"
  },
  {
    "code": "JPY",
    "name": "Japanese Yen",
    "symbol": "¥",
    "decimals": 0,
    "countries": "Japan"
  },
  {
    "code": "KES",
    "name": "Kenyan Shilling",
    "symbol": "KSh",
    "decimals": 2,
    "countries": "Kenya"
  },
  {
    "code": "KGS",
    "name": "Kyrgyzstani Som",
    "symbol": "с",
    "decimals": 2,
    "countries": "Kyrgyzstan"
  },
  {
    "code": "KHR",
    "name": "Cambodian Riel",
    "symbol": "៛",
    "decimals": 2,
    "countries": "Cambodia"
  },
  {
    "code": "KMF",
    "name": "Comorian Franc",
    "symbol": "CF",
    "decimals": 0,
    "countries": "Comoros"
  },
  {
    "code": "KPW",
    "name": "North Korean Won",
    "symbol": "₩",
    "decimals": 2,
    "countries": "North Korea"
  },
  {
    "code": "KRW",
    "name": "South Korean Won",
    "symbol": "₩",
    "decimals": 0,
    "countries": "South Korea"
  },
  {
    "code": "KWD",
    "name": "Kuwaiti Dinar",
    "symbol": "KD",
    "decimals": 3,
    "countries": "Kuwait"
  },
  {
    "code": "KYD",
    "name": "Cayman Islands Dollar",
    "symbol": "CI$",
    "decimals": 2,
    "countries": "Cayman Islands"
  },
  {
    "code": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol": "₸",
    "decimals": 2,
    "countries": "Kazakhstan"
  },
  {
    "code": "LAK",
    "name": "Lao Kip",
    "symbol": "₭",
    "decimals": 2,
    "countries": "Laos"
  },
  {
    "code": "LBP",
    "name": "Lebanese Pound",
    "symbol": "L£",
    "decimals": 2,
    "countries": "Lebanon"
  },
  {
    "code": "LKR",
    "name": "Sri Lankan Rupee",
    "symbol": "Rs",
    "decimals": 2,
    "countries": "Sri Lanka"
  },
  {
    "code": "LRD",
    "name": "Liberian Dollar",
    "symbol": "L$",
    "decimals": 2,
    "countries": "Liberia"
  },
  {
    "code": "LSL",
    "name": "Lesotho Loti",
    "symbol": "L",
    "decimals": 2,
    "countries": "Lesotho"
  },
  {
    "code": "LYD",
    "name": "Libyan Dinar",
    "symbol": "LD",
    "decimals": 3,
    "countries": "Libya"
  },
  {
    "code": "MAD",
    "name": "Moroccan Dirham",
    "symbol": "DH",
    "decimals": 2,
    "countries": "Morocco, Western Sahara"
  },
  {
    "code": "MDL",
    "name": "Moldovan Leu",
    "symbol": "L",
    "decimals": 2,
    "countries": "Moldova"
  },
  {
    "code": "MGA",
    "name": "Malagasy Ariary",
    "symbol": "Ar",
    "decimals": 2,
    "countries": "Madagascar"
  },
  {
    "code": "MKD",
    "name": "Macedonian Denar",
    "symbol": "ден",
    "decimals": 2,
    "countries": "North Macedonia"
  },
  {
    "code": "MMK",
    "name": "Myanmar Kyat",
    "symbol": "K",
    "decimals": 2,
    "countries": "Myanmar"
  },
  {
    "code": "MNT",
    "name": "Mongolian Tögrög",
    "symbol": "₮",
    "decimals": 2,
    "countries": "Mongolia"
  },
  {
    "code": "MOP",
    "name": "Macanese Pataca",
    "symbol": "MOP$",
    "decimals": 2,
    "countries": "Macao"
  },
  {
    "code": "MRU",
    "name": "Mauritanian Ouguiya",
    "symbol": "UM",
    "decimals": 2,
    "countries": "Mauritania"
  },
  {
    "code": "MUR",
    "name": "Mauritian Rupee",
    "symbol": "₨",
    "decimals": 2,
    "countries": "Mauritius"
  },
  {
    "code": "MVR",
    "name": "Maldivian Rufiyaa",
    "symbol": "Rf",
    "decimals": 2,
    "countries": "Maldives"
  },
  {
    "code": "MWK",
    "name": "Malawian Kwacha",
    "symbol": "MK",
    "decimals": 2,
    "countries": "Malawi"
  },
  {
    "code": "MXN",
    "name": "Mexican Peso",
    "symbol": "MX$",
    "decimals": 2,
    "countries": "Mexico"
  },
  {
    "code": "MYR",
    "name": "Malaysian Ringgit",
    "symbol": "RM",
    "decimals": 2,
    "countries": "Malaysia"
  },
  {
    "code": "MZN",
    "name": "Mozambican Metical",
    "symbol": "MT",
    "decimals": 2,
    "countries": "Mozambique"
  },
  {
    "code": "NAD",
    "name": "Namibian Dollar",
    "symbol": "N$",
    "decimals": 2,
    "countries": "Namibia"
  },
  {
    "code": "NGN",
    "name": "Nigerian Naira",
    "symbol": "₦",
    "decimals": 2,
    "countries": "Nigeria"
  },
  {
    "code": "NIO",
    "name": "Nicaraguan Córdoba",
    "symbol": "C$",
    "decimals": 2,
    "countries": "Nicaragua"
  },
  {
    "code": "NOK",
    "name": "Norwegian Krone",
    "symbol": "kr",
    "decimals": 2,
    "countries": "Norway, Svalbard"
  },
  {
    "code": "NPR",
    "name": "Nepalese Rupee",
    "symbol": "Rs",
    "decimals": 2,
    "countries": "Nepal"
  },
  {
    "code": "NZD",
    "name": "New Zealand Dollar",
    "symbol": "NZ$",
    "decimals": 2,
    "countries": "New Zealand, Cook Islands, Niue"
  },
  {
    "code": "OMR",
    "name": "Omani Rial",
    "symbol": "﷼",
    "decimals": 3,
    "countries": "Oman"
  },
  {
    "code": "PAB",
    "name": "Panamanian Balboa",
    "symbol": "B/.",
    "decimals": 2,
    "countries": "Panama"
  },
  {
    "code": "PEN",
    "name": "Peruvian Sol",
    "symbol": "S/",
    "decimals": 2,
    "countries": "Peru"
  },
  {
    "code": "PGK",
    "name": "Papua New Guinean Kina",
    "symbol": "K",
    "decimals": 2,
    "countries": "Papua New Guinea"
  },
  {
    "code": "PHP",
    "name": "Philippine Peso",
    "symbol": "₱",
    "decimals": 2,
    "countries": "Philippines"
  },
  {
    "code": "PKR",
    "name": "Pakistani Rupee",
    "symbol": "Rs",
    "decimals": 2,
    "countries": "Pakistan"
  },
  {
    "code": "PLN",
    "name": "Polish Zloty",
    "symbol": "zł",
    "decimals": 2,
    "countries": "Poland"
  },
  {
    "code": "PYG",
    "name": "Paraguayan Guaraní",
    "symbol": "₲",
    "decimals": 0,
    "countries": "Paraguay"
  },
  {
    "code": "QAR",
    "name": "Qatari Riyal",
    "symbol": "﷼",
    "decimals": 2,
    "countries": "Qatar"
  },
  {
    "code": "RON",
    "name": "Romanian Leu",
    "symbol": "lei",
    "decimals": 2,
    "countries": "Romania"
  },
  {
    "code": "RSD",
    "name": "Serbian Dinar",
    "symbol": "дин",
    "decimals": 2,
    "countries": "Serbia"
  },
  {
    "code": "RUB",
    "name": "Russian Ruble",
    "symbol": "₽",
    "decimals": 2,
    "countries": "Russia"
  },
  {
    "code": "RWF",
    "name": "Rwandan Franc",
    "symbol": "RF",
    "decimals": 0,
    "countries": "Rwanda"
  },
  {
    "code": "SAR",
    "name": "Saudi Riyal",
    "symbol": "﷼",
    "decimals": 2,
    "countries": "Saudi Arabia"
  },
  {
    "code": "SBD",
    "name": "Solomon Islands Dollar",
    "symbol": "SI$",
    "decimals": 2,
    "countries": "Solomon Islands"
  },
  {
    "code": "SCR",
    "name": "Seychellois Rupee",
    "symbol": "₨",
    "decimals": 2,
    "countries": "Seychelles"
  },
  {
    "code": "SDG",
    "name": "Sudanese Pound",
    "symbol": "ج.س",
    "decimals": 2,
    "countries": "Sudan"
  },
  {
    "code": "SEK",
    "name": "Swedish Krona",
    "symbol": "kr",
    "decimals": 2,
    "countries": "Sweden"
  },
  {
    "code": "SGD",
    "name": "Singapore Dollar",
    "symbol": "S$",
    "decimals": 2,
    "countries": "Singapore"
  },
  {
    "code": "SHP",
    "name": "Saint Helena Pound",
    "symbol": "£",
    "decimals": 2,
    "countries": "Saint Helena, Ascension"
  },
  {
    "code": "SLE",
    "name": "Sierra Leonean Leone",
    "symbol": "Le",
    "decimals": 2,
    "countries": "Sierra Leone"
  },
  {
    "code": "SOS",
    "name": "Somali Shilling",
    "symbol": "Sh",
    "decimals": 2,
    "countries": "Somalia"
  },
  {
    "code": "SRD",
    "name": "Surinamese Dollar",
    "symbol": "$",
    "decimals": 2,
    "countries": "Suriname"
  },
  {
    "code": "SSP",
    "name": "South Sudanese Pound",
    "symbol": "SS£",
    "decimals": 2,
    "countries": "South Sudan"
  },
  {
    "code": "STN",
    "name": "São Tomé and Príncipe Dobra",
    "symbol": "Db",
    "decimals": 2,
    "countries": "Sao Tome and Principe"
  },
  {
    "code": "SVC",
    "name": "Salvadoran Colón",
    "symbol": "₡",
    "decimals": 2,
    "countries": "El Salvador"
  },
  {
    "code": "SYP",
    "name": "Syrian Pound",
    "symbol": "S£",
    "decimals": 2,
    "countries": "Syria"
  },
  {
    "code": "SZL",
    "name": "Eswatini Lilangeni",
    "symbol": "E",
    "decimals": 2,
    "countries": "Eswatini, Swaziland"
  },
  {
    "code": "THB",
    "name": "Thai Baht",
    "symbol": "฿",
    "decimals": 2,
    "countries": "Thailand"
  },
  {
    "code": "TJS",
    "name": "Tajikistani Somoni",
    "symbol": "SM",
    "decimals": 2,
    "countries": "Tajikistan"
  },
  {
    "code": "TMT",
    "name": "Turkmenistani Manat",
    "symbol": "m",
    "decimals": 2,
    "countries": "Turkmenistan"
  },
  {
    "code": "TND",
    "name": "Tunisian Dinar",
    "symbol": "DT",
    "decimals": 3,
    "countries": "Tunisia"
  },
  {
    "code": "TOP",
    "name": "Tongan Paʻanga",
    "symbol": "T$",
    "decimals": 2,
    "countries": "Tonga"
  },
  {
    "code": "TRY",
    "name": "Turkish Lira",
    "symbol": "₺",
    "decimals": 2,
    "countries": "Turkey, Türkiye"
  },
  {
    "code": "TTD",
    "name": "Trinidad and Tobago Dollar",
    "symbol": "TT$",
    "decimals": 2,
    "countries": "Trinidad and Tobago"
  },
  {
    "code": "TWD",
    "name": "New Taiwan Dollar",
    "symbol": "NT$",
    "decimals": 2,
    "countries": "Taiwan"
  },
  {
    "code": "TZS",
    "name": "Tanzanian Shilling",
    "symbol": "TSh",
    "decimals": 2,
    "countries": "Tanzania"
  },
  {
    "code": "UAH",
    "name": "Ukrainian Hryvnia",
    "symbol": "₴",
    "decimals": 2,
    "countries": "Ukraine"
  },
  {
    "code": "UGX",
    "name": "Ugandan Shilling",
    "symbol": "USh",
    "decimals": 0,
    "countries": "Uganda"
  },
  {
    "code": "USD",
    "name": "US Dollar",
    "symbol": "$",
    "decimals": 2,
    "countries": "United States, Zimbabwe, Ecuador, Panama, Liberia"
  },
  {
    "code": "UYU",
    "name": "Uruguayan Peso",
    "symbol": "$U",
    "decimals": 2,
    "countries": "Uruguay"
  },
  {
    "code": "UZS",
    "name": "Uzbekistani Som",
    "symbol": "so'm",
    "decimals": 2,
    "countries": "Uzbekistan"
  },
  {
    "code": "VES",
    "name": "Venezuelan Bolívar",
    "symbol": "Bs.",
    "decimals": 2,
    "countries": "Venezuela"
  },
  {
    "code": "VND",
    "name": "Vietnamese Dong",
    "symbol": "₫",
    "decimals": 0,
    "countries": "Vietnam"
  },
  {
    "code": "VUV",
    "name": "Vanuatu Vatu",
    "symbol": "VT",
    "decimals": 0,
    "countries": "Vanuatu"
  },
  {
    "code": "WST",
    "name": "Samoan Tala",
    "symbol": "WS$",
    "decimals": 2,
    "countries": "Samoa"
  },
  {
    "code": "XAF",
    "name": "Central African CFA Franc",
    "symbol": "FCFA",
    "decimals": 0,
    "countries": "Cameroon, Chad, Central African Republic, Congo, Equatorial Guinea, Gabon"
  },
  {
    "code": "XCD",
    "name": "East Caribbean Dollar",
    "symbol": "EC$",
    "decimals": 2,
    "countries": "Antigua and Barbuda, Dominica, Grenada, Saint Lucia, Saint Vincent"
  },
  {
    "code": "XOF",
    "name": "West African CFA Franc",
    "symbol": "CFA",
    "decimals": 0,
    "countries": "Benin, Burkina Faso, Côte d'Ivoire, Guinea-Bissau, Mali, Niger, Senegal, Togo"
  },
  {
    "code": "XPF",
    "name": "CFP Franc",
    "symbol": "₣",
    "decimals": 0,
    "countries": "French Polynesia, New Caledonia, Wallis and Futuna"
  },
  {
    "code": "YER",
    "name": "Yemeni Rial",
    "symbol": "﷼",
    "decimals": 2,
    "countries": "Yemen"
  },
  {
    "code": "ZAR",
    "name": "South African Rand",
    "symbol": "R",
    "decimals": 2,
    "countries": "South Africa, Lesotho, Namibia, Eswatini"
  },
  {
    "code": "ZIG",
    "name": "Zimbabwe Gold",
    "symbol": "ZiG",
    "decimals": 2,
    "countries": "Zimbabwe"
  },
  {
    "code": "ZMW",
    "name": "Zambian Kwacha",
    "symbol": "ZK",
    "decimals": 2,
    "countries": "Zambia"
  },
  {
    "code": "ZWG",
    "name": "Zimbabwe Gold (ZWG)",
    "symbol": "ZWG",
    "decimals": 2,
    "countries": "Zimbabwe"
  },
  {
    "code": "ZWL",
    "name": "Zimbabwe Dollar",
    "symbol": "Z$",
    "decimals": 2,
    "countries": "Zimbabwe"
  }
];

const BY_CODE = CURRENCIES.reduce((acc, c) => { acc[c.code] = c; return acc; }, {});

export const getCurrencyMeta = (code) =>
  BY_CODE[(code || '').toUpperCase()] || { code: (code || '').toUpperCase(), name: code, symbol: code, decimals: 2, countries: '' };

export const currencyLabel = (code) => {
  const m = getCurrencyMeta(code);
  return `${m.code} · ${m.name}`;
};

/** Fuzzy search across code, currency name, symbol and country names. */
export const searchCurrencies = (query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return CURRENCIES;
  const starts = [];
  const contains = [];
  for (const c of CURRENCIES) {
    const code = c.code.toLowerCase();
    if (code.startsWith(q)) { starts.push(c); continue; }
    const hay = `${code} ${c.name} ${c.symbol} ${c.countries}`.toLowerCase();
    if (hay.includes(q)) contains.push(c);
  }
  return [...starts, ...contains];
};

const RECENT_KEY = 'fwm.recentCurrencies';

export const getRecentCurrencies = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    return Array.isArray(raw) ? raw.filter(c => BY_CODE[c]).slice(0, 5) : [];
  } catch { return []; }
};

export const rememberCurrency = (code) => {
  const c = (code || '').toUpperCase();
  if (!BY_CODE[c]) return;
  try {
    const next = [c, ...getRecentCurrencies().filter(x => x !== c)].slice(0, 5);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch { /* storage unavailable */ }
};
